import { format } from "date-fns";
import { epgChannels } from "./epg-channels";
import { v4 as uuidv4 } from "uuid";
import { faker } from "@faker-js/faker";

export const getToday = ({
  date = "2022-04-19",
  formatType = "yyyy-MM-dd",
} = {}) => format(new Date(date), formatType);

function generateData(channelUuid: string) {
  const data = [];
  const currentDate = format(new Date(), "yyyy-MM-dd");
  const startDate = new Date(`${currentDate}T08:00:00Z`);
  const endDate = new Date(`${currentDate}T18:00:00Z`);
  const image = `https://api.dicebear.com/7.x/pixel-art/svg?seed=${faker.internet.displayName()}`;
  let current = startDate;

  while (current < endDate) {
    const since = new Date(current); // Copy the start time
    since.setSeconds(0, 0); // Set seconds to 0 for exact minute

    // Random duration from 30 minutes to 2 hours
    const durationInMinutes = Math.floor(Math.random() * (120 - 30 + 1)) + 30;

    // Calculate till time by adding the random duration to the start time
    const till = new Date(since.getTime() + durationInMinutes * 60000);
    till.setSeconds(0, 0); // Set seconds to 0 for exact minute

    data.push({
      channelUuid,
      id: uuidv4(),
      title: faker.company.catchPhrase(),
      description: "",
      since: since.toISOString(),
      till: till.toISOString(),
      image,
    });

    current = new Date(till); // Move to the end of the current show
  }

  return data;
}

export const getResources = () => {
  const channels = epgChannels;

  const epg = generateData(channels[0].uuid);
  const data = channels.flatMap((channel) => generateData(channel.uuid));
  return { channels, epg: data };
};
